import Image from 'next/image'
import { BT } from './tokens'

// Мокап: квадратный монограмм на ink-фоне (круглый), mono-шрифт. Инициалы из name или fallback «МЕ».
export function Avatar({
    src,
    name,
    size = 28,
}: {
    src?: string | null
    name?: string | null
    size?: number
}) {
    const initials =
        (name || 'МЕ')
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map((s) => s[0]?.toUpperCase() ?? '')
            .join('') || 'М'

    if (src) {
        return (
            <Image
                src={src}
                alt={name || 'Автор'}
                width={size}
                height={size}
                className="rounded-full object-cover"
                style={{ width: size, height: size }}
            />
        )
    }
    return (
        <span
            aria-label={name || 'Автор'}
            style={{
                width: size,
                height: size,
                borderRadius: 999,
                background: BT.ink,
                color: '#fff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: BT.fontMono,
                fontSize: Math.max(9, Math.round(size * 0.36)),
                fontWeight: 700,
                letterSpacing: 0.3,
            }}
        >
            {initials}
        </span>
    )
}
